import type { GdprFeatureConfig } from './type';

export const gdpr: GdprFeatureConfig = {
    dataConsentsAcceptHeader: 'application/json',
    reloadGeorgeAfterUpdate: false,
    uniqueDocument: false,
};
